(function($) {
  $('.open-dialog').magnificPopup({
    type: 'inline',

    fixedContentPos: false,
    fixedBgPos: true,

    overflowY: 'auto',

    closeBtnInside: true,
    preloader: false,
    
    midClick: true,
    removalDelay: 300,
    mainClass: 'my-mfp-zoom-in'
  });
  $('.photo-upload').on('change', 'input[type="file"]', function(evt) {
    var tmppath = URL.createObjectURL(event.target.files[0]);
    if (tmppath) {
      $(this).siblings('.preview').html('<img src="'+tmppath+'">').show();
    } else {
      $(this).siblings('.preview').html('').hide();
    }
  });
})($);